import { Fragment } from 'react';
import { Grid, GridSize, Typography } from '@mui/material';

interface Props {
  title?: string;
  children?: React.ReactNode;
  titleRatio?: GridSize;
  childrenRatio?: GridSize;
}

const RowContentPrewrap = (props: Props) => {
  const { title, titleRatio = 1.8, children, childrenRatio = 10.2 } = props;

  return (
    <Fragment>
      <Grid item xs={titleRatio}>
        <Typography
          whiteSpace="pre-wrap"
          variant="caption"
          fontWeight="bold"
          lineHeight="14px"
        >
          {title}
        </Typography>
      </Grid>
      <Grid item xs={childrenRatio}>
        {children}
      </Grid>
    </Fragment>
  );
};

export default RowContentPrewrap;
